import axios from 'axios';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import { useContext, useEffect, useRef, useState } from 'react'
import MapContext from '../MapContext'
import { ListBox } from 'primereact/listbox';
import { Dialog } from 'primereact/dialog';
import './GetFeatureInfo.css'
import GeoJSON from 'ol/format/GeoJSON';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../../../store/hooks';
import { IService } from '../../../../features/layerSlice';
import { setPopupResult, setSelectedFeature, setSelectedFeatureList } from '../../../../features/selectionSlice';
import { SimpleGeometry } from 'ol/geom';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';


export default function GetFeatureInfo() {

    const map = useContext(MapContext);
    // const [selectedFeature, setSelectedFeature] = useState<any>(null);
    const [featureList, setFeatureList] = useState<any>(null);
    const [clickPosition, setclickPosition] = useState<any>(null);
    const toastConfirm = useRef<any>(null);
    const toastError = useRef<any>(null);
    const dispatch = useDispatch();
    const services: IService[] = useAppSelector((state) => state.layer.services);
    const showEtahsis: boolean = useAppSelector(state => state.toolbarState.showEtahsis);
    const selectedFeature: any = useAppSelector(state => state.selectionState.selectedFeature);
    const popupResult: any = useAppSelector(state => state.selectionState.popupResult);
    const token: any = useAppSelector(state => state.authState.token);
    const { t } = useTranslation();

    useEffect(() => {
        if(featureList && featureList.length){
            dispatch(setSelectedFeatureList(featureList));
        }
    }, [featureList]);

    useEffect(() => {
        map.on('singleclick', info);

        return () => {
            map.un('singleclick', info);
        }
    }, [services, showEtahsis])

    const info = async (e: any) => {
        setFeatureList([]);
        const layers = map.getLayers().getArray();
        const view = map.getView();
        const infoLayers = layers.filter(obj => obj.get('infoLayer') && obj.getVisible());
        let featureList = []
        for (const layer of infoLayers) {
            const source = (layer as TileLayer<TileWMS>).getSource()!;
            const url: string = source.getFeatureInfoUrl(
                e.coordinate,
                view.getResolution()!,
                view.getProjection(),
                {
                    QUERY_LAYERS: source.getParams().LAYERS,
                    info_format: 'application/json',
                    feature_count: 10,
                    token: token
                }
            )!

            const features = await axios.get(url);
            featureList.push(features.data.features)
        }
        featureList = featureList.flat();
        if (showEtahsis) {  
            featureList = featureList.filter((list: any) => list.id.split('.')[0] === 'parsel_usr')
        }

        if (featureList.length === 1) {
            if (showEtahsis) {
                if (featureList[0].properties.tahsis_durumu === 2) {
                    showConfirm()
                    selectFeature(featureList[0])
                    setclickPosition(null);
                }
                else {
                    toastError.current.show({ severity: 'error', summary: `${t('TEXT.Error')}`, detail: `${t('TEXT.You have selected a full parcel. Please select an empty parcel.')}`, life: 5000 });
                }

            }
            else {
                selectFeature(featureList[0])
                setclickPosition(null);
            }
        } else {
            //e tahsis için birden fazla feature varsa featurelara zoom yapsın
            if (showEtahsis) {
                const geojson = new GeoJSON()
                const olFeature :any = geojson.readFeature(featureList[0])
                olFeature.getGeometry()?.transform('EPSG:3857', 'EPSG:4326');
                map.getView().fit(olFeature.getGeometry()?.transform('EPSG:4326', 'EPSG:3857') as SimpleGeometry, { padding: [10, 10, 10, 10] })
            }
            else {
                setclickPosition(e.pixel);
                let layerName: any;
                const featureListArray = featureList.map(obj => {

                    layerName = obj.id.split('.')[0];
                    let id: any = obj.properties.id
                    if (layerName === 'parsel_usr' || layerName === 'parsel_pasif_usr') {
                        id = obj.properties.ada_parsel
                    }
                    if (layerName === 'osb_sinir_usr' || layerName === 'ebler_usr' || layerName === 'tgb_usr') {
                        id = '(' + obj.properties.adi + ')'
                    }

                    const layerAlias = services.find((service: any) => service.layers
                        .some((layer: any) => layer.name === layerName))?.layers
                        .find(layer => layer.name === layerName)?.alias
                    return { name: layerAlias + ' ' + `${layerName === 'parsel_usr' || layerName === 'parsel_pasif_usr' || layerName === 'osb_sinir_usr' || layerName === 'ebler_usr' || layerName === 'tgb_usr' ? (id ? id : '') : ''}`, value: obj }
                })

                if (layerName === 'uip_1000' || layerName === 'eb_uip_1000' || layerName === 'tgb_uip_1000') {
                    const list = featureList.filter((list: any) => list.properties.layername === 'PlanSiniri' || list.properties.layername === 'PlanDegisiklikSiniri')
                    selectFeature(list[0])
                }
                else {
                    setFeatureList(featureListArray);

                }
            }
        }
    }

    const selectFeature = (feature: any) => {
        if (services && feature) {
            const geojson = new GeoJSON()
            const olFeature :any = geojson.readFeature(feature)
            olFeature.getGeometry()?.transform('EPSG:3857', 'EPSG:4326');
            const geojsonFeature :any = geojson.writeFeature(olFeature);
            dispatch(setSelectedFeature(JSON.parse(geojsonFeature)))
        }
        return () => dispatch(setSelectedFeature(undefined))
    }

    const showConfirm = () => {
        toastConfirm.current.show({
            severity: 'warn', sticky: true, content: (
                <div className="flex flex-column" style={{ flex: '1' }}>
                    <div className="text-center">
                        <i className="pi pi-exclamation-triangle" style={{ fontSize: '3rem' }}></i>
                        <h4 style={{ textTransform: 'uppercase' }}>{t('TEXT.Attention')}</h4>
                        <p>{t('TEXT.Are you sure you want to apply for e-allocation with the parcel you have chosen?')}</p>
                    </div>
                    <div className="flex" style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                        <Button type="button" label={t('TEXT.Yes')} onClick={() => dispatch(setPopupResult(true))} className="p-button-success" style={{ width: '5em' }} />
                        <Button type="button" label={t('TEXT.No')} onClick={clearToast} className="p-button-secondary" style={{ width: '5em', marginLeft: '1em', background: 'var(--cancel-color)', borderColor: 'var(--cancel-color)' }} />
                    </div>
                </div>
            )
        });
    }

    useEffect(() => {
        if (popupResult) {
            window.open(`${process.env.REACT_APP_BASE_URL}appeal/?tahsis=${selectedFeature.properties.id}#/`, '_self', 'noopener,noreferrer')
            clearToast();
        }
        return () => { dispatch(setPopupResult(false)) }
    }, [popupResult])

    const clearToast = () => {
        toastConfirm.current.clear()
        dispatch(setSelectedFeature(undefined))
    }

    return (
        <>
            {
                !showEtahsis && featureList && featureList.length > 1 &&
                <Dialog style={{ position: 'fixed', top: clickPosition[1], left: clickPosition[0] }} header="Veri Listesi" visible={true} modal={false} onHide={() => { setFeatureList([]) }}>
                    <ListBox options={featureList} onChange={(e) => { selectFeature(e.value); setFeatureList([]) }} optionLabel="name" style={{ width: '15rem' }}></ListBox>
                </Dialog>
            }
            <Toast ref={toastError} className='error-toast' />
            <Toast ref={toastConfirm} className='confirm-toast' position="bottom-center" />
        </>
    )
}
